import React from 'react';
import { Workflow } from '../../../types/workflow';

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="flex items-start gap-4 py-2 border-b border-wash last:border-0">
      <div className="text-xs text-muted w-44 flex-shrink-0">{label}</div>
      <div className="text-sm text-ink min-w-0 break-words">{value}</div>
    </div>
  );
}

function Card({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="bg-white border border-trim rounded-xl p-5">
      <h3 className="text-sm font-semibold text-ink mb-3">{title}</h3>
      <div>{children}</div>
    </section>
  );
}

export function IdentityTab({ workflow }: { workflow: Workflow }) {
  const id = workflow.identity;
  const gov = workflow.governance;
  const pol = workflow.policy;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <Card title="Metadata">
        <Row label="workflow_id"        value={<span className="font-mono text-xs">{id.workflow_id}</span>} />
        <Row label="namespace"          value={<span className="font-mono text-xs">{id.namespace}</span>} />
        <Row label="slug"               value={<span className="font-mono text-xs">{id.slug}</span>} />
        <Row label="version"            value={<span className="font-mono text-xs">{workflow.version}</span>} />
        <Row label="created by"         value={id.created_by} />
        <Row label="created at"         value={new Date(id.created_at).toLocaleString()} />
        <Row label="updated at"         value={new Date(id.updated_at).toLocaleString()} />
        <Row label="git commit"         value={<span className="font-mono text-xs">{id.git_commit}</span>} />
        <Row label="environment"        value={<span className="uppercase">{id.deployment_environment}</span>} />
        <Row label="lifecycle"          value={id.lifecycle_state} />
      </Card>

      <Card title="Governance">
        <Row label="owner team"             value={gov.owner_team} />
        <Row label="escalation contacts"    value={gov.escalation_contacts.join(', ')} />
        <Row label="business approver"      value={gov.business_approver} />
        <Row label="technical approver"     value={gov.technical_approver} />
        <Row label="compliance scope"       value={gov.compliance_scope.join(', ')} />
        <Row label="data classification"    value={gov.data_classification} />
        <Row label="risk level"             value={gov.risk_level} />
      </Card>

      <Card title="Policy">
        <Row label="retention policy"       value={pol.retention_policy} />
        <Row label="residency policy"       value={pol.residency_policy} />
        <Row label="secrets used"           value={
          <div className="flex gap-1 flex-wrap">
            {pol.secrets_used.map(s => (
              <span key={s} className="font-mono text-xs px-1.5 py-0.5 rounded bg-wash text-copy">{s}</span>
            ))}
          </div>
        } />
        <Row label="approval requirements"  value={pol.approval_requirements} />
        <Row label="data access scope"      value={pol.data_access_scope} />
      </Card>
    </div>
  );
}
